var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowWithoutGrowing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.821 32.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.6 -1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24949",
    "data-name": "Path 24949",
    d: "M18.862,18H14.287A2.287,2.287,0,0,0,12,20.287v9.149a2.287,2.287,0,0,0,2.287,2.287h4.574a2.287,2.287,0,0,0,2.287-2.287V20.287A2.287,2.287,0,0,0,18.862,18ZM14.287,29.436V20.287h4.574v9.149Z",
    transform: "translate(1.436 2.298)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24950",
    "data-name": "Path 24950",
    d: "M8.862,21H4.287A2.287,2.287,0,0,0,2,23.287v5.718a2.287,2.287,0,0,0,2.287,2.287H8.862a2.287,2.287,0,0,0,2.287-2.287V23.287A2.287,2.287,0,0,0,8.862,21ZM4.287,29.005V23.287H8.862v5.718Z",
    transform: "translate(0 2.729)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24951",
    "data-name": "Path 24951",
    d: "M28.862,13H24.287A2.287,2.287,0,0,0,22,15.287V30.154a2.287,2.287,0,0,0,2.287,2.287h4.574a2.287,2.287,0,0,0,2.287-2.287V15.287A2.287,2.287,0,0,0,28.862,13ZM24.287,30.154V15.287h4.574V30.154Z",
    transform: "translate(2.872 1.58)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24952",
    "data-name": "Path 24952",
    d: "M6.145,19.154a1.152,1.152,0,0,0,.282-.035A48.19,48.19,0,0,0,18.142,14.43a48.1,48.1,0,0,0,10.876-8.4V8.862a1.144,1.144,0,1,0,2.287,0V3.144A1.144,1.144,0,0,0,30.162,2H24.443a1.144,1.144,0,0,0,0,2.287H27.5a45.775,45.775,0,0,1-10.482,8.152A45.876,45.876,0,0,1,5.863,16.9a1.144,1.144,0,0,0,.282,2.255Z",
    transform: "translate(0.429 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowWithoutGrowing);
export default __webpack_public_path__ + "static/media/GrowWithoutGrowing.4ecfdc2f1e8451d5f87184bbe3a4c76c.svg";
export { ForwardRef as ReactComponent };